// 9fbef606107a605d69c0edbcd8029e5d
import { call, put, takeEvery } from 'redux-saga/effects';
import ShopByLookStylitics from '@tcp/core/src/services/abstractors/shopByLookStylitics';
import { getUnbxdXappConfigs } from '@tcp/core/src/components/features/browse/ProductListing/container/ProductListing.saga';

import {
  FETCH_SHOP_BY_LOOK_STYLITICS_REQUEST,
  FETCH_SHOP_BY_LOOK_UNBXD_REQUEST,
} from './ShopByLookStylitics.constants';
import {
  fetchShopByLookStyliticsSuccess,
  fetchShopByLookStyliticsFailure,
  fetchShopByLookUnbxdSuccess,
  fetchShopByLookUnbxdFailure,
} from './ShopByLookStylitics.actions';

export function* fetchShopByLookStyliticsData({ payload }) {
  const { tagName, count, uniqueKey, isRedirectToPDP } = payload;

  try {
    const data = yield call(ShopByLookStylitics.getData, {
      count,
      tags: tagName,
      isRedirectToPDP,
      uniqueKey,
    });
    yield put(fetchShopByLookStyliticsSuccess(uniqueKey, data));
  } catch (error) {
    yield put(fetchShopByLookStyliticsFailure(uniqueKey, error.message));
  }
}

export function* fetchShopByLookUnbxdData({ payload }) {
  const { productIds, uniqueKey } = payload;
  try {
    const xappURLConfig = yield call(getUnbxdXappConfigs);
    const data = yield call(ShopByLookStylitics.getUnbxdData, {
      productIds,
      uniqueKey,
      xappURLConfig,
    });
    yield put(fetchShopByLookUnbxdSuccess(uniqueKey, data));
  } catch (error) {
    yield put(fetchShopByLookUnbxdFailure(uniqueKey, error.message));
  }
}

function* ShopByLookStyliticsSaga() {
  yield takeEvery(FETCH_SHOP_BY_LOOK_STYLITICS_REQUEST, fetchShopByLookStyliticsData);
  yield takeEvery(FETCH_SHOP_BY_LOOK_UNBXD_REQUEST, fetchShopByLookUnbxdData);
}

export default ShopByLookStyliticsSaga;
